import React from 'react';
import { Typography } from '@mui/material';
export default function Paragraph(_a) {
    var children = _a.children;
    return (React.createElement(Typography, { mt: 4, mb: 0, variant: "body2" }, children));
}
